import faqJson from '@/content/faq.json';

export interface FaqItem {
  question: string;
  answer: string;
}

/** Dados em `src/content/faq.json`, editáveis pelo painel em /admin. */
export const FAQ = faqJson as FaqItem[];
